import React, { useEffect } from 'react';
import styles from './TemplateRegistretion.module.scss';
import { ReactComponent as TempaletsHouse } from '../../../../../resource/TempaletsHouse.svg';
import { useSelector } from 'react-redux';
import { modeList } from '../../../constants/modeList';

const TemplateRegistretion = ({
  template,
  changeTemlate,
  classTempale,
  changeTemlateModem,
  choice,
}) => {
  const parse = () => {
    const textContent = template.message.replace(/<\/?[^>]+(>|$)/g, '').trim();
    return textContent;
  };

  const currentHouse = useSelector(
    (state) => state.housingStockStore.currentHouse
  );

  const clickTemplate = () => {
    changeTemlate(template);
    changeTemlateModem(modeList.SELECTED_MODE);
  };

  useEffect(() => {
    const listItems = document.querySelectorAll('.listItem');

    listItems.forEach((item) => {
      const header = item.querySelector('.name');
      const text = item.querySelector('.message');

      const headerHeight = header.offsetHeight;
      const itemHeight = item.offsetHeight;
      const availableHeight = itemHeight - headerHeight;

      const lineHeight = parseInt(window.getComputedStyle(text).lineHeight, 10);
      const maxLines = Math.floor(availableHeight / lineHeight);
      text.style.webkitLineClamp = maxLines;
    });
  });

  return (
    <div
      className={classTempale ? `${styles.list} ${styles.active}` : styles.list}
      onClick={clickTemplate}
    >
      <div>
        <TempaletsHouse />
      </div>
      <div
        className="listItem"
        style={{ width: '100%' }}
      >
        <div className={styles.groupName}>
          <div className={`${styles.name} name`}>{template.name}</div>
          {currentHouse?.houseTypeAccess.id === template.id && choice && (
            <span className={styles.activeTemplate}>Действующий</span>
          )}
        </div>
        <div className={`${styles.message} message`}>{parse()}</div>
      </div>
    </div>
  );
};

export default TemplateRegistretion;
